import { store } from './store.js';
/**
 * Phase 2 Integration Script
 * Connects gamification system with wizard logic
 */

(function () {
    'use strict';

    console.log('🎮 Phase 2 Integration initializing...');

    // Wait for services to be ready
    document.addEventListener('DOMContentLoaded', function () {
        // Show gamification UI when problem screen is active
        showGamificationUI();

        // Connect wizard events with gamification
        setupGamificationHooks();

        console.log('✅ Phase 2 Integration complete');
    });

    /**
     * Show gamification UI in problem screen
     */
    function showGamificationUI() {
        const compactTopBar = document.getElementById('compactTopBar');
        const problemScreen = document.getElementById('problemScreen');

        if (compactTopBar && problemScreen) {
            // Show gamification header when problem screen is active
            const observer = new MutationObserver(() => {
                if (!problemScreen.classList.contains('hidden')) {
                    compactTopBar.style.display = 'flex';
                    if (window.GamificationService) {
                        window.GamificationService.updateUI();
                    }
                } else {
                    compactTopBar.style.display = 'none';
                }
            });

            observer.observe(problemScreen, {
                attributes: true,
                attributeFilter: ['class']
            });

            // Initial check
            if (!problemScreen.classList.contains('hidden')) {
                compactTopBar.style.display = 'flex';
            }
        }
    }

    /**
     * Setup hooks for gamification events
     */
    function setupGamificationHooks() {
        // Listen for wizard feedback events (already dispatched by Phase 1)

        // Hook: Step correct
        const originalShowWizardFeedback = window.showWizardFeedback;
        if (originalShowWizardFeedback) {
            window.showWizardFeedback = function (message, isCorrect, autoHide = false) {
                // Call original
                originalShowWizardFeedback(message, isCorrect, autoHide);

                // Add gamification & JUICY FEEDBACK
                if (isCorrect) {
                    if (window.GamificationService) {
                        window.GamificationService.stepCorrect();
                    }

                    // 1. Confetti Burst (Mini)
                    if (window.confetti) {
                        confetti({
                            particleCount: 50,
                            spread: 60,
                            origin: { y: 0.7 },
                            colors: ['#6366F1', '#EC4899', '#F59E0B'] // App colors
                        });
                    }

                    // 2. Play Sound
                    if (window.SoundService) {
                        SoundService.playSuccess();
                    }

                    // 3. Avatar Jump
                    if (window.DetectiveMentor) {
                        window.DetectiveMentor.jump();
                    }
                }
            };
        }

        // Hook: Problem completed
        const originalShowSuccessAnimation = window.showSuccessAnimation;
        if (originalShowSuccessAnimation) {
            window.showSuccessAnimation = function (message) {
                // Call original
                originalShowSuccessAnimation(message);

                // Add gamification
                if (window.GamificationService && store.state) {
                    const problem = store.state.problems[store.state.currentProblem];
                    const problemType = problem?.type || 'suma';

                    // Count fails (simple heuristic - could be tracked better)
                    const failCount = 0; // TODO: Track actual fail count

                    window.GamificationService.completeProblem(problemType, failCount);
                }
            };
        }

        // Listen for problem start to track context
        document.addEventListener('problemStarted', handleProblemStart);
    }

    /**
     * Handle problem start event
     */
    function handleProblemStart(event) {
        if (!window.GamificationService || !event.detail) return;

        const { context } = event.detail;
        const progress = window.GamificationService.getProgress();

        // Track unlocked contexts
        if (context && !progress.unlockedContexts.includes(context)) {
            progress.unlockedContexts.push(context);
            window.GamificationService.saveProgress();

            // Check for explorer badge
            if (window.BadgeSystem) {
                BadgeSystem.checkBadges();
            }
        }
    }

    // Expose utilities
    window.Phase2Integration = {
        showGamificationUI,
        setupGamificationHooks
    };

})();
